(function () {
    // private methods
    var priv = {
        eventListener: function (eventType, cb) {
            if (window.addEventListener) {
                window.addEventListener(eventType, function (e) {
                    cb(e);
                }, false);
            } else if (window.attachEvent) { // ie8
                window.attachEvent('on' + eventType, function (e) {
                    cb(e);
                });
            }
        },
        handleMsg: function (msg) {
            // parse data
            var data = msg.data;
            if(typeof msg.data !== "object") {
                data = JSON.parse(msg.data);
            }
            switch (data.type) {
                case 'ndrstnd' :
                    window.tracker_user_id = data.data;
                    break;
                default:
                    console.log('iframeItem - Unknown message type : ' + data.type);
            }
        },
        getDocumentHeight: function () {
            // from http://stackoverflow.com/questions/1145850/get-height-of-entire-document-with-javascript
            var body = document.body, html = document.documentElement;
            return Math.max(body.scrollHeight, body.offsetHeight,
                html.clientHeight, html.scrollHeight, html.offsetHeight);
        },
    };

    var IframeItemClass = function () {
        this.identity = getQueryParameter('identity');
        var z = this;
        priv.eventListener('load', function () {
            z.sendDocumentHeight();
            z.sendMsg(
                'ready-to-go'
            );
        });
        priv.eventListener('message', function (e) {
            priv.handleMsg(e);
        });
    };
    IframeItemClass.prototype.sendDocumentHeight = function (e) {
        this.sendMsg(
            'height',
            priv.getDocumentHeight()
        );
    };
    IframeItemClass.prototype.sendMsg = function (type, data) {
        var message = JSON.stringify({
            type: type,
            identity: this.identity,
            data: data
        });
        parent.postMessage(message, '*');
    };

    window.iframeItem = new IframeItemClass();
})();

function getQueryParameter(param) {
    var vars = {};
    window.location.href.replace( location.hash, '' ).replace(
        /[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
        function( m, key, value ) { // callback
            vars[key] = value !== undefined ? value : '';
        }
    );

    if ( param ) {
        return vars[param] ? vars[param] : null;
    }
    return vars;
}